import { fetchy } from '@bridebook/web/lib/fetchy';
import getServerSideAnalyticsProps from '@bridebook/web/lib/utils/get-server-side-analytics-props';
import type { IServerSideTrack } from '@bridebook/web/lib/utils/server-side-track';
import type { TBookTrackEventRequestBody } from '@bridebook/web/pages/api/a/t/booked';

const bookedSupplierTrack = ({
  state,
  event,
  identifyProps,
  specificEventProps,
  bookedSupplier,
  category = '',
}: IServerSideTrack & TBookTrackEventRequestBody): Promise<any> => {
  const body: TBookTrackEventRequestBody = {
    event,
    identifyProps,
    genericProps: getServerSideAnalyticsProps(state),
    specificEventProps,
    source: 'web',
    bookedSupplier,
    category,
  };

  return fetchy().post('/api/a/t/booked', null, body);
};

export default bookedSupplierTrack;
